import Config from 'services/config/config';
import callWebService, { callTypes } from 'services/utils/networks/network';
import { REJECT } from '../salesApprovals/type';
import { APPROVAL_LIST, ACCEPT,SITE_ABORT_APPROVAL,SITE_ABORT_APPROVAL_FINANCE, FETCH_APPROVE_REJECT_LIST } from './type';

export const getApprovalList = (page = 1) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.approvals.mrfApprovalList}?page=${page}`
  );

  if (res) {
    const { data } = res;
    dispatch({ type: APPROVAL_LIST, payload: data.response.data });
    return true;
  }
};

export const acceptApproval = (siteId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    '',
    `${Config.approvals.mrfApprovalAccept}${siteId}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: ACCEPT, payload: data.response.data });
    return true;
  }
};

export const rejectApproval = (siteId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    '',
    `${Config.approvals.mrfApprovalReject}${siteId}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: REJECT, payload: data.response.data });
    return data.response.status;
  }
};
export const getSiteAbortApproval = (page = 1) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.installation.getSiteAbortApproval}?page=${page}`
  );

  if (res) {
    const { data } = res;
    dispatch({ type: SITE_ABORT_APPROVAL, payload: data.response.data });
    return true;
  }
};

export const getSiteAbortApprovalFinance = (queryObj=null, page = 1) => async (dispatch) => {
  let filterQuery = `page=${page}`;
  if(queryObj !== null){
    filterQuery+= `&site_no=${queryObj.site_no}&site_name=${queryObj.site_name}&page=${page}`;
  }
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.installation.getSiteAbortApprovalFinance}?${filterQuery}`
  );

  if (res) {
    const { data } = res;
    dispatch({ type: SITE_ABORT_APPROVAL_FINANCE, payload: data.response.data });
    return true;
  }
};

// acceptSiteStatusApproval
export const acceptSiteStatusApproval = (siteId,status = 1,siteStatus = null) => async (dispatch) => {
  if(siteStatus == 31 || siteStatus == 34){
    const res = await callWebService(
      callTypes.get,
      '',
      `${Config.installation.siteLertApproval}?site_id=${siteId}&status=${status}&siteStatus=${siteStatus}`
    );
    if (res) {
      const { data } = res;
      if(data.status != false) {  
        dispatch({ type: ACCEPT, payload: data.response.data });
        return true;
      } else {
        dispatch({ type: ACCEPT, payload: null });
        return false;
      }
    }
  }else{
    const res = await callWebService(
      callTypes.get,
      '',
      `${Config.installation.siteStageStatusApproval}?site_id=${siteId}&status=${status}`
    );
    if (res) {
      const { data } = res;
      if(data.status != false) {  
        dispatch({ type: ACCEPT, payload: data.response.data });
        return true;
      } else {
        dispatch({ type: ACCEPT, payload: null });
        return false;
      }
    }
  }
  
};


export const rejectAbortApproval = (siteId,siteStatus = null) => async (dispatch) => {
  
  if(siteStatus == 31 || siteStatus == 34){
    const res = await callWebService(
      callTypes.get,
      '',
      `${Config.installation.siteLertApproval}?site_id=${siteId}&status=2&siteStatus=${siteStatus}`
    );
    if (res) {
      const { data } = res;
      dispatch({ type: ACCEPT, payload: data.response.data });
      return true;
    }
  }else{
    const res = await callWebService(
      callTypes.get,
      '',
      `${Config.installation.siteStageStatusApproval}?site_id=${siteId}&status=2`
    );
    if (res) {
      const { data } = res;
      dispatch({ type: ACCEPT, payload: data.response.data });
      return true;
    }
  }
};

export const siteStatusCSV = (queryObj=null, page = 1) => async (dispatch) => {
  let filterQuery = `page=${page}`;
  if(queryObj !== null){
    filterQuery+= `&site_no=${queryObj.site_no}&site_name=${queryObj.site_name}`;
  }
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.installation.siteStatusCSV}?${filterQuery}`
  );
  if (res) {
    return res?.data?.response;
  }
  return false;
};

export const fetchApprovedRejectedList = (queryObj=null, page = 1) => async (dispatch) => {
  let filterQuery = `page=${page}`;
  if(queryObj !== null){
    filterQuery+= `&site_no=${queryObj.site_no}&site_name=${queryObj.site_name}&page=${page}`;
  }
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.installation.getapproveRejectDataFinance}?${filterQuery}`
  );

  if (res) {
    const { data } = res;
    dispatch({ type: FETCH_APPROVE_REJECT_LIST, payload: data.response.data });
    return true;
  }
};
